import Link from "next/link";
import { Text } from "@chakra-ui/react";
import { MAIN_ROUTES, SERVICES_ROUTES } from "@/constants/routes";

export const TERMS_AND_CONDITIONS = [
  <span key="1">
    You can buy the service now and choose a later start date of the subscription. (Email{" "}
    <Link href="mailto:support@cloudmylab.com" legacyBehavior>
      <Text color="brand.100" display="inline" _hover={{ textDecoration: "underline" }}>
        support
      </Text>
    </Link>{" "}
    for later start date)
  </span>,
  "The coupon code is case-sensitive.",
  "No Refunds- All Sales are Final.",
  "One email ID can avail the offer only once.",
  <span key="2">
    Cloudmylab coupon/discount codes on our website are also subject to Cloudmylab’s
    General{" "}
    <Link href={MAIN_ROUTES.TERMS_OF_SERVICE} legacyBehavior>
      <Text color="brand.100" display="inline" _hover={{ textDecoration: "underline" }}>
        Terms of Service.
      </Text>
    </Link>{" "}
    Also, Cloudmylab’s decision will be final in case of any dispute.
  </span>,
];

export const NAVIGATION_LIST = [
  {
    label: "Hosted Emulators",
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.HOSTED_EMULATORS}`,
  },
  {
    label: "Ansible Automation",
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.AUTOMATION}`,
  },
  {
    label: "Bare Metal",
    path: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.BAREMETAL}`,
  },
];
